import { Box, LinearProgress, Stack, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { useMeasurementUnits } from '~/common/use-measurement-units'
import { usePlotAreaData } from './use-plot-area-data'
import { useValueFlash } from './use-value-flash'

const flashSx = (isFlashing) => (theme) => ({
  px: 0.5,
  borderRadius: 1,
  transition: 'background-color 0.1s ease-in',
  ...(isFlashing && {
    animation: 'valueFlash 1.2s ease-out forwards',
    '@keyframes valueFlash': {
      '0%': { backgroundColor: alpha(theme.palette.success.main, 0.3) },
      '100%': { backgroundColor: 'transparent' },
    },
  }),
})

export const PlotArea = () => {
  const { areaM2 = 0, loading } = usePlotAreaData()
  const { formatArea } = useMeasurementUnits()
  const areaFlash = useValueFlash(areaM2)

  if (loading) return <LinearProgress />

  const formatted = formatArea(areaM2)
  const spaceIdx = formatted.lastIndexOf(' ')
  const value = formatted.slice(0, spaceIdx)
  const unit = formatted.slice(spaceIdx + 1)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, fontSize: '0.65rem', letterSpacing: '0.05em' }}>
        AREA
      </Typography>
      <Stack direction='row' spacing={0.5} alignItems='flex-end' sx={[{ mt: -0.75 }, flashSx(areaFlash)]}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: 'info.main' }}>
          {value}
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
          {unit}
        </Typography>
      </Stack>
    </Box>
  )
}
